import React from "react";
import { NavLink } from "react-router-dom";

const HeroSectionWebinarBan = () => {
  return (
    <section className="container-fluid" style={{ paddingTop: "45px" }}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap');

          .banner-custome-padding {
            padding: 0 60px;
          }

          .banner-wrap {
            background: linear-gradient(135deg, #FFF8ED 0%, #FFF3D6 50%, #FFF0E0 100%);
            border-radius: 24px;
            border: 1.5px solid #FACF7A;
            overflow: hidden;
            position: relative;
            min-height: 260px;
            max-width: 1100px;
            margin: 0 auto;
            font-family: 'Inter', sans-serif;
          }

          .deco-circle {
            position: absolute;
            border-radius: 50%;
            opacity: 0.18;
          }

          .inner {
            display: flex;
            align-items: stretch;
            gap: 0;
            position: relative;
            z-index: 2;
          }

          .left-panel {
            flex: 0 0 52%;
            padding: 48px 36px 40px 40px;
            display: flex;
            flex-direction: column;
            gap: 10px;
            border-right: 1px dashed #F5C870;
          }

          .event-label {
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
            color: #B87A10;
            margin-bottom: 2px;
          }

          .title-row {
            display: flex;
            align-items: baseline;
            gap: 10px;
            flex-wrap: wrap;
          }

          .word-summer {
            font-family: 'Playfair Display', Georgia, serif;
            font-size: 42px;
            font-weight: 700;
            color: #E8851A;
            line-height: 1;
            position: relative;
          }

          .word-members {
            font-size: 32px;
            font-weight: 700;
            color: #1A1A1A;
            line-height: 1;
          }

          .word-meet {
            font-size: 32px;
            font-weight: 700;
            color: #1A1A1A;
            line-height: 1;
          }

          .word-year {
            font-size: 32px;
            font-weight: 700;
            color: #E8851A;
            line-height: 1;
          }

          .tagline {
            font-size: 13px;
            color: #7A5E30;
            font-weight: 400;
            letter-spacing: 0.3px;
            margin-top: 2px;
          }

          .sponsor-pill {
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            background: #fff;
            border: 1.5px solid #F0C060;
            border-radius: 16px;
            padding: 10px 18px 8px;
            margin-top: 8px;
            width: fit-content;
          }

          .sponsor-logo {
            height: 20px;
            width: auto;
          }

          .sponsor-label {
            font-size: 9px;
            font-weight: 600;
            color: #B87A10;
            letter-spacing: 1.5px;
            text-transform: uppercase;
          }

          .right-panel {
            flex: 1;
            padding: 40px 36px 40px 36px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 14px;
          }

          .detail-row {
            display: flex;
            align-items: flex-start;
            gap: 10px;
          }

          .detail-icon {
            width: 30px;
            height: 30px;
            background: #E8851A;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-top: 1px;
          }

          .detail-text-main {
            font-size: 15px;
            font-weight: 600;
            color: #1A1A1A;
            line-height: 1.3;
          }

          .detail-text-sub {
            font-size: 12px;
            color: #7A5E30;
            line-height: 1.4;
            margin-top: 2px;
          }

          .divider {
            height: 1px;
            background: repeating-linear-gradient(90deg, #F5C870 0px, #F5C870 6px, transparent 6px, transparent 12px);
            margin: 2px 0;
          }

          .btn-row {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            align-items: center;
            margin-top: 4px;
          }

          .btn-outline {
            padding: 10px 22px;
            border-radius: 100px;
            border: 2px solid #E8851A;
            background: transparent;
            color: #E8851A;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            letter-spacing: 0.3px;
            transition: all 0.22s ease;
            font-family: 'Inter', sans-serif;
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }

          .btn-outline:hover {
            background: #E8851A;
            color: #fff;
            transform: translateY(-1px);
          }

          .btn-fill {
            padding: 10px 22px;
            border-radius: 100px;
            border: none;
            background: #E8851A;
            color: #fff;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            letter-spacing: 0.3px;
            transition: all 0.22s ease;
            font-family: 'Inter', sans-serif;
            box-shadow: 0 4px 16px rgba(232,133,26,0.30);
            text-decoration: none;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }

          .btn-fill:hover {
            background: #C56B0A;
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(232,133,26,0.40);
          }

          .deco-lemon, .deco-leaf, .deco-drop, .deco-sun-ring {
            position: absolute;
            pointer-events: none;
            z-index: 1;
          }

          @keyframes float1 { 0%,100%{transform:translateY(0) rotate(-10deg)} 50%{transform:translateY(-6px) rotate(-8deg)} }
          @keyframes float2 { 0%,100%{transform:translateY(0) rotate(15deg)} 50%{transform:translateY(-8px) rotate(17deg)} }
          @keyframes pulse-ring { 0%,100%{opacity:0.12} 50%{opacity:0.22} }

          .anim-float1 { animation: float1 3.8s ease-in-out infinite; }
          .anim-float2 { animation: float2 4.5s ease-in-out infinite; }
          .anim-pulse { animation: pulse-ring 3s ease-in-out infinite; }

          @media (max-width: 768px) {
            .banner-wrap {
              margin: 0 15px;
            }
            .banner-custome-padding {
              padding: 0 15px;
            }
            .inner {
              flex-direction: column;
            }
            .left-panel {
              flex: 0 0 auto;
              border-right: none;
              border-bottom: 1px dashed #F5C870;
            }
            .word-summer {
              font-size: 32px;
            }
            .word-members,
            .word-meet,
            .word-year {
              font-size: 24px;
            }
          }
        `}
      </style>

      <div className="banner-wrap">
        {/* bg deco circles */}
        <div className="deco-circle anim-pulse" style={{ width: "220px", height: "220px", background: "#F5A623", top: "-70px", right: "30px" }}></div>
        <div className="deco-circle" style={{ width: "130px", height: "130px", background: "#FBA834", bottom: "-40px", left: "20px" }}></div>
        <div className="deco-circle" style={{ width: "80px", height: "80px", background: "#FFD580", top: "20px", left: "180px", opacity: "0.25" }}></div>

        {/* floating lemon slice */}
        <div className="deco-lemon anim-float2" style={{ top: "12px", right: "16px", opacity: "0.55" }}>
          <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27" cy="27" r="25" fill="#FFE066" stroke="#E8C020" strokeWidth="1.5" />
            <circle cx="27" cy="27" r="18" fill="#FFF4A0" stroke="#E8C020" strokeWidth="0.8" />
            <line x1="27" y1="9" x2="27" y2="45" stroke="#D4A800" strokeWidth="0.8" opacity="0.6" />
            <line x1="9" y1="27" x2="45" y2="27" stroke="#D4A800" strokeWidth="0.8" opacity="0.6" />
            <line x1="14" y1="14" x2="40" y2="40" stroke="#D4A800" strokeWidth="0.8" opacity="0.6" />
            <line x1="40" y1="14" x2="14" y2="40" stroke="#D4A800" strokeWidth="0.8" opacity="0.6" />
          </svg>
        </div>

        {/* floating mint leaf */}
        <div className="deco-leaf anim-float1" style={{ bottom: "22px", right: "22px", opacity: "0.45" }}>
          <svg width="36" height="48" viewBox="0 0 36 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 46 C18 46 2 34 2 18 C2 8 10 2 18 2 C26 2 34 8 34 18 C34 34 18 46 18 46Z" fill="#5DB87A" stroke="#3D8A5A" strokeWidth="1" />
            <line x1="18" y1="4" x2="18" y2="46" stroke="#3D8A5A" strokeWidth="1" opacity="0.5" />
            <line x1="10" y1="12" x2="26" y2="24" stroke="#3D8A5A" strokeWidth="0.7" opacity="0.4" />
            <line x1="8" y1="22" x2="28" y2="32" stroke="#3D8A5A" strokeWidth="0.7" opacity="0.4" />
          </svg>
        </div>

        {/* sun ring top-left */}
        <div className="deco-sun-ring anim-pulse" style={{ top: "-18px", left: "-18px", opacity: "0.18" }}>
          <svg width="90" height="90" viewBox="0 0 90 90" fill="none">
            <circle cx="45" cy="45" r="38" stroke="#FBA834" strokeWidth="3" strokeDasharray="8 5" />
          </svg>
        </div>

        {/* straw decoration */}
        <div style={{ position: "absolute", bottom: "0", right: "110px", zIndex: "1", opacity: "0.3" }}>
          <svg width="12" height="70" viewBox="0 0 12 70" fill="none">
            <rect x="1" y="0" width="10" height="70" rx="5" fill="#E8851A" />
            <rect x="3" y="0" width="3" height="70" rx="2" fill="#fff" opacity="0.4" />
          </svg>
        </div>

        <div className="inner">
          {/* LEFT */}
          <div className="left-panel">
            {/* <div className="event-label">Members Event · London 2026</div> */}
            <div>
              <div className="title-row">
                <span className="word-summer">Summer</span>
              </div>
              <div className="title-row" style={{ marginTop: "2px" }}>
                <span className="word-members">Members</span>
                <span className="word-meet">Meet</span>
                <span className="word-year">2026</span>
              </div>
            </div>
            <div className="tagline">Make your voice count</div>

            <div className="sponsor-pill">
              <img src="assets/images/peratera-logo-black.svg" alt="Peratera" className="sponsor-logo" />
              <span className="sponsor-label">Event sponsor</span>
            </div>
          </div>

          {/* RIGHT */}
          <div className="right-panel">
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div className="detail-row">
                <div className="detail-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                </div>
                <div>
                  <div className="detail-text-main">Friday, 26<sup style={{ fontSize: "10px" }}>th</sup> June 2026</div>
                  <div className="detail-text-sub">06:00 PM BST</div>
                </div>
              </div>

              <div className="divider"></div>

              <div className="detail-row">
                <div className="detail-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" /><circle cx="12" cy="9" r="2.5" /></svg>
                </div>
                <div>
                  <div className="detail-text-main">1864 Rooftop Bar &amp; Kitchen</div>
                  <div className="detail-text-sub">6th Floor, John Lewis, 300 Oxford Street<br />London WC1 1DX <br /> <strong> Private entrance -</strong> 4 Old Cavendish St, London W1G 0NE </div>
                </div>
              </div>
            </div>

            <div className="btn-row">
              <NavLink className="btn-outline" to="/summer-meet-2026">
                View Details
              </NavLink>
              <a className="btn-fill" href="/summer-meet-2026#rsvp-form">
                Register Now ✦
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionWebinarBan;
